import { Button, Modal } from "reactstrap";
import { useAtomValue } from "jotai";
import { tenantIDAtom } from "../../atoms/GlobalAtoms";
import CopyGroup from "../Modals/CopyGroup";
import { useNavigate } from "react-router-dom";

interface Props {
  open: boolean;
  onClose: () => void;
  formID: string;
  share?: boolean;
}

/**
 * FormBuilderModal - Modal that provides links to form after successful creation
 */
export default function FormBuilderSuccessModal({
  open,
  onClose,
  formID,
  share = false,
}: Props) {
  const navigate = useNavigate();
  const tenantID = useAtomValue(tenantIDAtom);
  const link = `${window.location.origin}/forms/${tenantID}/${formID}`;

  return (
    <Modal
      className="modal-dialog-centered px-2"
      isOpen={open}
      toggle={onClose}
    >
      <div className="p-3">
        <div className="d-flex justify-content-end">
          <i
            className="mdi mdi-close cursor-pointer text-dark text-lg"
            onClick={onClose}
          />
        </div>
        {share ? (
          <h2 className="text-center mb-0 text-dark">Share your form</h2>
        ) : (
          <>
            <h2 className="text-center mb-0 text-dark">
              Form Successfully Saved
            </h2>
            <p className="text-center small pt-2 pb-1">
              Your form is ready to be shared
            </p>
          </>
        )}
        <div className="px-0 px-md-1">
          <CopyGroup
            name="Share Link"
            description="Copy and paste this link to share the form."
            link={link}
          />
          <CopyGroup
            name="Embed Code (iframe)"
            description="Copy and paste this code in your website."
            link={`${link}?iframe=true`}
          />
          <div className="d-flex justify-content-center">
            {!window.location.pathname.includes("publicForms") && (
              <Button
                color="light"
                onClick={() => {
                  onClose();
                  navigate(`/clouds/${tenantID}/settings/publicForms`);
                }}
              >
                Go to Saved
              </Button>
            )}
            <Button onClick={() => window.open(link, "_blank")} color="primary">
              Preview Form
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
